import Vue from 'vue'
import VueRouter from 'vue-router'
import userService from '../services/user.service'
Vue.use(VueRouter)

const routes = [

 
    {
      path: '/login',
      name: 'Login',
      component: () => import('../views/Login'),
      meta :{
        log:false,
        admin : false,
        maestro : false,
        auth: false,
      }
    },

    // {
    //   path: '/',
    //   name: 'inicio',
    //   component: () => import('../views/Proximamente'),
    //   meta :{
    //     log:false,
    //     admin : false,
    //     maestro : false,
    //     auth: false,
    //   }
    // },

    {
      path: '/',
      name: 'inicio',
      component: () => import('../views/Home'),
      meta :{
        log:false,
        admin : false,
        maestro : false,
        auth: false,
      }
    },
  
  
   

  {
    path: '/auth',
    name: 'autentificacion',
    component: () => import('../views/Autentificacion'),
    meta :{
      log:true,
      admin : true,
      maestro : false,
      auth: false
    }
  },
  
  {
    path: '/administrador',
    name: 'Dashboard',
    component: () => import('../views/Dashboard'),
    meta :{
      log:true,
      admin : true,
      maestro : false,
      auth: true, 
    }
  },
  

  {
    path: '/aviso-de-privacidad',
    name: 'Aviso',
    component: () => import('../views/AvisoPrivacidad'),
    meta :{
     log:false,
     admin : false,
     maestro : false,
     auth: false
    }
  },

  {
    path: '/terminos-y-condiciones',
    name: 'Aviso',
    component: () => import('../views/PoliticasPrivacidad'),
    meta :{
     log:false,
     admin : false,
     maestro : false,
     auth: false
    }
  },

  {
    path: '*',
    name: '404',
    component: () => import('../views/Error404'),
    meta :{
     log:false,
     admin : false,
     maestro : false,
     auth: false
    }
  },


   

]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach( async (to, from, next) => {

  let meta_admin = to.matched.some(record=>record.meta.admin);
  let meta_maestro = to.matched.some(record=>record.meta.maestro);
  let meta_log = to.matched.some(record=>record.meta.log);
  let meta_auth = to.matched.some(record=>record.meta.auth);

  let tokenexp = await userService.tokenexp()
  let check =false //comprobar si esta logeado
  let admin =false;
  let maestro =false;
  let type =''


  if(tokenexp){ // ver que el token no este expirado.
    localStorage.removeItem('tkn')
    localStorage.removeItem('ath') //limpiar el localstorage
    next()
  }


  let response = await userService.getData()

  if(response.status =='error'){
    localStorage.removeItem('tkn')
    localStorage.removeItem('ath')
  }


  if(response.status=='success'){ //comprobar que sea un login valido.
    check =true;
    let isAdmin = userService.isAdmin(response.result);
    admin = isAdmin.admin
    type = isAdmin.type

    let isTch = userService.isTch(response.result);
    maestro = isTch.tch
  
  }

  let ath = await userService.getAth();

 
  // borrar el localstorage cada que vayamos a login.
  
  if(to.path==='/login' && check){
    localStorage.removeItem('tkn')
    localStorage.removeItem('ath')
    
    next()
  }

  //redireccionamientos por rol.

  if(!meta_log) next();

  if(meta_log && !check)  next('/login');

  if(meta_admin){
        if(admin){
        
          if(meta_auth){
            if(ath){
              next();
            }else{
              localStorage.removeItem('tkn')
              localStorage.removeItem('ath')
              next('/login')
            }
          }else{ //...proximamente rutas que no requieran autentificacion
            next()
          }
          
        }else{
          localStorage.removeItem('tkn')
          localStorage.removeItem('ath')
          next('/')
        }
  }else if(meta_maestro){
    if(maestro){
        
      if(meta_auth){
        if(ath){
          next();
        }else{
          localStorage.removeItem('tkn')
          localStorage.removeItem('ath')
          next('/login')
        }
      }else{ //...proximamente rutas que no requieran autentificacion
        next()
      }
      
    }else{
      localStorage.removeItem('tkn')
      localStorage.removeItem('ath')
      next('/login')
    }

  }else{
    next()
  }

 
});




export default router

